import React from 'react';

import { CellRenderer, MainColumns } from '../../../../../../components/TableGrid';
import { ManagerDetail } from '../../../../../../generated/model/models';
import DetailsDataTableWithHistory from '../../shared/DetailsDataTableWithHistory';

export interface Props {
  data?: ManagerDetail;
}

const columns: MainColumns[] = [
  {
    field: 'managerName',
    minWidth: 200,
    flex: 1,
    cellRenderer: CellRenderer.ValueOrUnknown,
    cellClass: 'multipleLineCell',
    autoHeight: true,
  },
  { field: 'managerType', minWidth: 200, flex: 1 },
  { field: 'officialValidFrom', minWidth: 150, flex: 1 },
  { field: 'officialValidTo', minWidth: 150, flex: 1 },
];

const OwnershipManagers: React.FC<Props> = ({ data }) => {
  return (
    <DetailsDataTableWithHistory
      title={'managers'}
      translationsScope={'companies:companyOwnership'}
      data={data}
      columns={columns}
      defaultHistoryToggleValue={true}
    />
  );
};

export default OwnershipManagers;
